import { darkTheme, lightTheme } from '@controlrooms/design-tokens';

export const managePageTheme = Object.fromEntries(
  Object.entries({ light: lightTheme, dark: darkTheme }).map(([key, theme]) => [
    key,
    {
      headerNavBg: theme.color.surface[2],
      headerNavTitle: theme.color.text.core['-emphasis'],
      headerNavText: theme.color.text.core['-emphasis'],
      headerNavTextActive: theme.color.focus[3],
      headerNavTextDisabled: theme.color.text.core['-tertiary'],
      headerNavSelectedBorder: theme.color.focus[2],
      headerNavBorder: theme.color.surface[2],
    },
  ]),
);
